export default __webpack_public_path__ + "static/media/1828739.75013e98.svg";